import { Container, Sprite, Rectangle } from 'pixi.js';
import { EVENT, IMAGES, MainSignals, TickCallData } from '../../../../settings/constants';
import { SCENE_1, SCENE_LENGTH } from '../../../../settings/positions';
import SceneBase from '../base/SceneBase';
import { TweenMax, Power1 } from 'gsap';
import { playSfx } from '../../../../helpers/SoundManager';

const HIT_AREA = [-550, -300, 250, 650];

export default class Scene1 extends SceneBase {
  josef: Container = new Container();

  hand0: Sprite;
  hand1: Sprite;
  hand2: Sprite;

  charVisible = false;
  animActive = false;

  soundDelayChar: any = null;

  constructor(signals: MainSignals) {
    super(signals, SCENE_1, 1, 1);

    // parts
    const bg = Sprite.from(IMAGES.BG_1);
    bg.anchor.set(0.5);
    this.addChild(bg);

    this.hand0 = Sprite.from('1-char-hand-0.png');
    this.hand1 = Sprite.from('1-char-hand-1.png');
    this.hand2 = Sprite.from('1-char-hand-2.png');

    this.setJosef();

    // interaction
    this.hitArea = new Rectangle(HIT_AREA[0], HIT_AREA[1], HIT_AREA[2], HIT_AREA[3]);
    this.interactive = true;
    this.on('pointerover', this.playAnimation.bind(this));
    this.on('pointerdown', this.playAnimation.bind(this));

    // listeners
    signals.stateCall.add(this.stateCall, this);
  }

  stateCall(event: string): void {
    if (event === EVENT.STATE.SPEECH_DONE) {
      setTimeout(() => {
        this.playAnimation();
      }, 1500);
    }
  }

  playAnimation(): void {
    if (this.isActive) {
      this.playAnim();
    }
  }

  // --------------------------------------------------------------
  // Josef
  // --------------------------------------------------------------

  setJosef(): void {
    this.josef.alpha = 0;
    this.addChild(this.josef);

    const bottom = Sprite.from('1-char-bottom.png');
    bottom.anchor.set(0.5);
    this.josef.addChild(bottom);

    this.hand0.anchor.set(0.2, 0.3);
    this.hand0.rotation = 0.2;
    this.hand0.y = -160;

    this.hand0.x = -410;
    this.josef.addChild(this.hand0);

    const top = Sprite.from('1-char-top.png');
    top.anchor.set(0.5);
    this.josef.addChild(top);

    this.hand1.anchor.set(0.8, 0.8);
    this.hand1.rotation = 0.3;
    this.hand1.x = -322;
    this.hand1.y = -110;
    this.josef.addChild(this.hand1);

    this.hand2.anchor.set(0.75, 0.5);
    this.hand2.rotation = 0.1;
    this.hand2.x = -370;
    this.hand2.y = -180;
    this.josef.addChild(this.hand2);

    // for hit area debug
    // this.buttonMode = true;
    // const hit = new Graphics();
    // hit.beginFill(0xff0000, 0.5);
    // hit.drawRect(HIT_AREA[0], HIT_AREA[1], HIT_AREA[2], HIT_AREA[3]);
    // hit.endFill();
    // this.addChild(hit);
  }

  checkChar(value: number): void {
    this.showChar(value > this.show + SCENE_LENGTH * 0.5);
  }

  showChar(value: boolean): void {
    if (this.charVisible !== value) {
      this.charVisible = value;

      TweenMax.killTweensOf(this.josef);
      if (this.charVisible) {
        TweenMax.to(this.josef, 0.8, { alpha: 1, ease: Power1.easeInOut });
        this.soundDelayChar = setTimeout(() => {
          playSfx('1-char-show');
        }, 100);
      } else {
        TweenMax.to(this.josef, 0.4, { alpha: 0, ease: Power1.easeInOut });
        clearTimeout(this.soundDelayChar);
      }
    }
  }

  playAnim(): void {
    if (this.charVisible && !this.animActive) {
      this.animActive = true;

      const animTime = 0.8;
      const ease = Power1.easeInOut;
      const yoyo = true;
      const repeat = 1;
      const repeatDelay = 1.2;

      TweenMax.to(this.hand0, animTime, {
        rotation: 0,
        y: -165,
        ease,
        yoyo,
        repeat,
        repeatDelay,
      });

      TweenMax.to(this.hand1, animTime, {
        rotation: 0,
        x: -315,
        y: -133,
        ease,
        yoyo,
        repeat,
        repeatDelay,
      });

      TweenMax.to(this.hand2, animTime, {
        rotation: 0,
        x: -378,
        y: -190,
        ease,
        yoyo,
        repeat,
        repeatDelay,
        onComplete: this.animComplete.bind(this),
      });

      setTimeout(() => {
        playSfx('1-coffee');
      }, 300);
    }
  }

  animComplete(): void {
    this.animActive = false;
  }

  // --------------------------------------------------------------
  // State switching
  // --------------------------------------------------------------

  tickCall(data: TickCallData): void {
    super.tickCall(data);

    // check states
    const { scroll } = data;
    this.checkChar(scroll);
  }
}
